import { createSlice } from '@reduxjs/toolkit';

interface IBirthDate {
  day: number | null;
  month: number | null;
  year: number | null;
}

interface IBirthTime {
  hour: string;
  minute: string;
  period: 'AM' | 'PM' | string;
}

interface IQ2025State {
  name: string;
  birthDate: IBirthDate;
  birthPlace: string;
  birthTime: IBirthTime;
  gender: string;
}
const initialState: IQ2025State = {
  name: '',
  birthDate: { day: null, month: null, year: null },
  birthPlace: '',
  birthTime: { hour: '01', minute: '00', period: 'AM' },
  gender: '',
};

export const q2025Slice = createSlice({
  name: '2025',
  initialState,
  reducers: {
    setNameAction: (state, action) => {
      state.name = action.payload;
    },
    setBirthDateAction: (state, action) => {
      state.birthDate = action.payload;
    },
    setBirthPlaceAction: (state, action) => {
      state.birthPlace = action.payload;
    },
    setBirthTimeAction: (state, action) => {
      state.birthTime = action.payload;
    },
    setGenderAction: (state, action) => {
      state.gender = action.payload;
    },
  },
});

export const {
  setNameAction,
  setBirthDateAction,
  setBirthPlaceAction,
  setBirthTimeAction,
  setGenderAction,
} = q2025Slice.actions;

export const q2025Reducer = q2025Slice.reducer;
